import axios from 'axios';

export function fetchSessions({
  projectId,
  groupId,
  historical = false,
  page = 1
}) {
  const params = {
    project_id: projectId,
    historical,
    ...(groupId && { group_id: groupId }),
    ...(historical && { page_number: page })
  };
  const urlParams = new URLSearchParams(params).toString();
  return axios.get(`/streaming_sessions?${urlParams}`);
}

export function submitEndSession(streamingSessionId) {
  return axios.delete(`/streaming_sessions/${streamingSessionId}`);
}
